/** Kurye konumunun tazeliği: panel rozeti ve haritadaki işaret rengi. */
export type LocationFreshness = 'fresh' | 'recent' | 'stale' | 'off' | 'none';

/** Yeşil: bu süreden yeni. */
export const FRESH_MINUTES = 3;
/** Turuncu: bu süreye kadar; sonrası gri ("konum eski"). */
export const RECENT_MINUTES = 10;

export const parseUtc = (iso?: string | null): Date | null => {
  if (!iso) return null;
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(iso);
  const d = new Date(hasZone ? iso : `${iso}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const isLocationOff = (state?: string | null) => state === 'denied' || state === 'service_off';

export interface LocationInfo {
  freshness: LocationFreshness;
  /** Son konumdan bu yana geçen dakika (konum yoksa null). */
  minutes: number | null;
}

export const locationInfo = (
  r: { locationAt?: string | null; locationState?: string | null },
  now: number = Date.now(),
): LocationInfo => {
  const at = parseUtc(r.locationAt);
  const minutes = at ? Math.max(0, Math.floor((now - at.getTime()) / 60000)) : null;
  if (isLocationOff(r.locationState)) return { freshness: 'off', minutes };
  if (minutes == null) return { freshness: 'none', minutes };
  if (minutes < FRESH_MINUTES) return { freshness: 'fresh', minutes };
  if (minutes <= RECENT_MINUTES) return { freshness: 'recent', minutes };
  return { freshness: 'stale', minutes };
};

export const freshnessColor = (f: LocationFreshness): 'success' | 'warning' | 'default' | 'error' =>
  f === 'fresh' ? 'success' : f === 'recent' ? 'warning' : f === 'off' ? 'error' : 'default';

/** Haritadaki işaretin rengi (tema dışı, sabit). */
export const freshnessHex = (f: LocationFreshness): string =>
  f === 'fresh' ? '#2e7d32' : f === 'recent' ? '#ed6c02' : f === 'off' ? '#d32f2f' : '#757575';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** "az önce", "8 dk önce", "2 sa önce", "21.10 14:05". */
export const agoText = (t: Translate, minutes: number | null, iso?: string | null): string => {
  if (minutes == null) return '—';
  if (minutes < 1) return t('courierModule.map.justNow');
  if (minutes < 60) return t('courierModule.map.minutesAgo', { count: minutes });
  if (minutes < 24 * 60) return t('courierModule.map.hoursAgo', { count: Math.floor(minutes / 60) });
  const d = parseUtc(iso);
  return d ? d.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
};

export const kmText = (km?: number | null): string =>
  km == null ? '—' : km < 1 ? `${Math.round(km * 1000)} m` : `${km.toLocaleString('tr-TR', { maximumFractionDigits: 1 })} km`;
